"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sentToUnderwriterSchema = exports.policyNumberSchema = exports.premiumFeesSchema = exports.oceanCargoWarehouseSchema = exports.oceanCargoLossesSchema = exports.oceanCargoExposuresSchema = exports.oceanCargoCoverageSchema = exports.oceanCargoSchema = exports.lossesSchema = exports.locationSchema = exports.brokerSchema = void 0;
const utilSchemas_1 = require("./utilSchemas");
const exposures_1 = require("../policy/exposures");
const location_1 = require("../policy/location");
const joi_1 = __importDefault(require("joi"));
const arrayOfNumbers = joi_1.default.array().items(joi_1.default.number());
const arrayOfStrings = joi_1.default.array().items(joi_1.default.string());
const assuredSchema = joi_1.default.object().keys({
    id: joi_1.default.string().allow(""),
    name: joi_1.default.string().required(),
    address: utilSchemas_1.addressSchema,
    ein: joi_1.default.string().allow("")
});
const userSchema = joi_1.default.object().keys({
    id: joi_1.default.string().required(),
    email: joi_1.default.string().required()
});
exports.brokerSchema = joi_1.default.object().keys({
    id: joi_1.default.string().allow(""),
    email: joi_1.default.string().required(),
    name: joi_1.default.string().required(),
    phone: joi_1.default.string().allow(""),
    ein: joi_1.default.string().allow(""),
    address: utilSchemas_1.addressSchema.required(),
    office: joi_1.default.string().required(),
    partnerId: joi_1.default.string().required()
});
const sizeAndLimitSchema = joi_1.default.object().keys({
    averageValue: joi_1.default.number().min(0).allow(null, ""),
    maximumValue: joi_1.default.number().min(0).allow(null, ""),
    desiredLimit: joi_1.default.number().min(0).allow(null, "")
});
const conveyanceSizeAndLimitSchema = joi_1.default.object().keys({
    vesselOrAircraft: sizeAndLimitSchema.optional(),
    oneShipment: sizeAndLimitSchema.optional(),
    truckOrRailcar: sizeAndLimitSchema.optional(),
    packageMailOrParcelPost: sizeAndLimitSchema.optional(),
    bargeOrTow: sizeAndLimitSchema.optional()
});
const fileSchema = joi_1.default.object().keys({
    documentPath: joi_1.default.string().required(),
    documentName: joi_1.default.string().required(),
    bucketName: joi_1.default.string().required(),
    size: joi_1.default.number().min(0).required(),
    fileType: joi_1.default.string().required(),
    success: joi_1.default.boolean().optional(),
    downloadUrl: joi_1.default.string().optional()
});
const numberOfAnnualSalesSchema = joi_1.default.object().keys({
    currency: joi_1.default.string().allow(""),
    value: joi_1.default.number().min(0).allow(null).allow("").optional()
});
const coverageFieldsSchema = joi_1.default.object().keys({
    coverageForExhibition: joi_1.default.boolean().allow(null, "").optional(),
    salespersonsSamplesCoverage: joi_1.default.number()
        .min(0)
        .allow("N/A", null)
        .optional(),
    exhibitionCoverage: joi_1.default.number().min(0).allow("N/A", null).optional()
});
const exposuresSchema = coverageFieldsSchema.keys({
    primaryCommodity: joi_1.default.string().optional().allow(null, ""),
    secondaryCommodities: arrayOfStrings.optional(),
    goodsInsuredDescription: joi_1.default.string().max(256).optional().allow(""),
    isTemperatureSensitive: joi_1.default.boolean().allow(null).optional(),
    temperatureDesiredCoverage: joi_1.default.string()
        .valid(...Object.values(exposures_1.eExposureTempDesiredCoverage))
        .optional()
        .allow("", null),
    allGoodsBeContainerized: joi_1.default.boolean().allow(null).optional(),
    detailedPackagingDescription: joi_1.default.string().optional().allow(""),
    valuation: joi_1.default.string()
        .valid(...Object.values(exposures_1.eExposureValuation))
        .optional()
        .allow("", null),
    numberOfAnnualSales: numberOfAnnualSalesSchema.allow(null).optional(),
    annualShipmentVolume: joi_1.default.number().min(0).allow(null).optional(),
    targetPremium: joi_1.default.number().min(0).allow(null).optional(),
    coverageForDomesticShipments: joi_1.default.boolean().allow(null).optional(),
    primaryDomesticShipment: joi_1.default.number().min(0).allow(null),
    contingentDomesticShipment: joi_1.default.number().min(0).allow(null),
    primaryInternationalShipment: joi_1.default.number().min(0).allow(null),
    contingentInternationalShipment: joi_1.default.number().min(0).allow(null),
    totalInternationalShipment: joi_1.default.when("coverageForDomesticShipments", {
        is: true,
        then: joi_1.default.number().min(0).allow(null),
        otherwise: joi_1.default.number().min(0).allow(null).optional()
    }),
    currentDeductible: joi_1.default.number().min(1).allow(null, "").optional(),
    maximumDesiredCoverageLimit: joi_1.default.number().min(0).allow(null).optional(),
    conveyanceSizeAndLimits: conveyanceSizeAndLimitSchema.optional(),
    acknowledgeExcludeCommodities: joi_1.default.boolean().required()
});
const yearRegex = /^((17|18|19|20)\d{2}|none)$/i;
const claimHistorySchema = joi_1.default.object().keys({
    year: joi_1.default.number().optional(),
    totalGrossLosses: joi_1.default.number().allow(null).optional(),
    numberOfLosses: joi_1.default.number().allow(null).optional()
});
const confirmNoKnowLossSchema = joi_1.default.object().keys({
    confirmed: joi_1.default.boolean(),
    confirmedBy: joi_1.default.string().required()
});
const getOccupancyOptions = Object.values(location_1.eOccupancy);
const getCommodityStates = Object.values(location_1.eCommodityState);
exports.locationSchema = joi_1.default.object({
    locationNo: joi_1.default.number().min(0).required(),
    buildingNo: joi_1.default.string().allow(""),
    address: utilSchemas_1.addressSchema.required(),
    occupancy: joi_1.default.string()
        .valid(...getOccupancyOptions)
        .required(),
    thirdPartyLocation: joi_1.default.boolean().allow("UNKNOWN").required(),
    maximunInventoryValue: joi_1.default.number().min(0).required(),
    constructionType: joi_1.default.string().required(),
    yearBuilt: joi_1.default.string().regex(yearRegex).required(),
    yearLastRoofUpdate: joi_1.default.string().regex(yearRegex).allow("").optional(),
    primaryCommodity: joi_1.default.string().optional(),
    secondaryCommodities: arrayOfStrings.optional(),
    commodityState: joi_1.default.string()
        .valid(...getCommodityStates)
        .required(),
    desiredLimit: joi_1.default.number().min(0).required(),
    currentDeductible: joi_1.default.number().min(0).allow(null, "").optional(),
    desiredDeductible: joi_1.default.number().min(0).required(),
    desiredNATCATPerilsSublimit: joi_1.default.number().min(0).required(),
    willGoodsBeStoredInContainers: joi_1.default.boolean().optional(),
    securityProtectionsInPlace: arrayOfStrings.optional(),
    locationLossesLastFiveYears: joi_1.default.when("storageLossesLastFiveYears", {
        is: true,
        then: joi_1.default.boolean().required(),
        otherwise: joi_1.default.boolean().optional()
    }),
    yearsOfClaimHistory: joi_1.default.number().min(0).max(5).optional(),
    claimsHistory: joi_1.default.when("locationLossesLastFiveYears", {
        is: true,
        then: joi_1.default.array().items(claimHistorySchema).required(),
        otherwise: joi_1.default.array().items(claimHistorySchema).optional()
    }),
    lossRecordAvailable: joi_1.default.boolean()
        .allow(null)
        .when("claimsHistory", {
        is: joi_1.default.number().greater(0),
        then: joi_1.default.boolean().required(),
        otherwise: joi_1.default.boolean().optional()
    }),
    confirmNoKnowLossHistory: joi_1.default.when("lossRecordAvailable", {
        is: false,
        then: confirmNoKnowLossSchema.required(),
        otherwise: confirmNoKnowLossSchema.optional()
    }),
    lossRecordDocuments: joi_1.default.when("locationLossesLastFiveYears", {
        is: true,
        then: joi_1.default.when("confirmNoKnowLossHistory ", {
            is: true,
            then: joi_1.default.array().items(fileSchema).required(),
            otherwise: joi_1.default.array().items(fileSchema).optional()
        })
    }),
    claimDescription: joi_1.default.string().max(256).allow("").optional()
});
const warehouseSchema = joi_1.default.object({
    coverageForGoodsInStorage: joi_1.default.boolean().required(),
    scheduleOfValuesFile: fileSchema.optional(),
    locations: joi_1.default.array().items(exports.locationSchema.optional()).min(0).optional(),
    storageLossesLastFiveYears: joi_1.default.boolean().required()
});
exports.lossesSchema = joi_1.default.object({
    yearsOfClaimHistory: joi_1.default.number().min(0).max(5).optional(),
    claimsHistory: joi_1.default.array().items(claimHistorySchema).optional(),
    lossRecordAvailable: joi_1.default.boolean().allow(null).optional(),
    lossRecordDocuments: joi_1.default.array().items(fileSchema).optional(),
    confirmNoKnowLossHistory: confirmNoKnowLossSchema.optional(),
    claimDescription: joi_1.default.string().max(256).allow("").optional()
});
exports.oceanCargoSchema = joi_1.default.object({
    partnerId: joi_1.default.string().required(),
    effectiveDate: joi_1.default.string().allow(""),
    hasPreviousPolicy: joi_1.default.boolean(),
    assured: assuredSchema.required(),
    broker: exports.brokerSchema.required(),
    channel: joi_1.default.string().required(),
    exposures: exposuresSchema.required(),
    losses: joi_1.default.when("hasPreviousPolicy", {
        is: false,
        then: exports.lossesSchema.optional(),
        otherwise: exports.lossesSchema.required()
    }),
    user: userSchema.required(),
    warehouse: warehouseSchema.required()
})
    .required()
    .unknown(true);
exports.oceanCargoCoverageSchema = joi_1.default.object({
    partnerId: joi_1.default.string().required(),
    partnerIds: joi_1.default.object().required(),
    effectiveDate: joi_1.default.string().allow(""),
    hasPreviousPolicy: joi_1.default.boolean(),
    assured: assuredSchema.required(),
    broker: exports.brokerSchema.required(),
    channel: joi_1.default.string().required(),
    user: userSchema.required(),
    warehouse: joi_1.default.object({ coverageForGoodsInStorage: joi_1.default.boolean() })
})
    .required()
    .unknown(true);
exports.oceanCargoExposuresSchema = joi_1.default.object({
    partnerId: joi_1.default.string().required(),
    channel: joi_1.default.string().required(),
    exposures: exposuresSchema.required(),
    user: userSchema.required()
})
    .required()
    .unknown(true);
exports.oceanCargoLossesSchema = joi_1.default.object({
    partnerId: joi_1.default.string().required(),
    channel: joi_1.default.string().required(),
    losses: joi_1.default.when("hasPreviousPolicy", {
        is: false,
        then: exports.lossesSchema.optional(),
        otherwise: exports.lossesSchema.required()
    }),
    user: userSchema.required()
})
    .required()
    .unknown(true);
exports.oceanCargoWarehouseSchema = joi_1.default.object({
    partnerId: joi_1.default.string().required(),
    channel: joi_1.default.string().required(),
    user: userSchema.required(),
    warehouse: warehouseSchema.required()
})
    .required()
    .unknown(true);
exports.premiumFeesSchema = coverageFieldsSchema
    .keys({
    commodities: arrayOfNumbers.required(),
    valuation: joi_1.default.string()
        .valid(exposures_1.eExposureValuation.CIF10, exposures_1.eExposureValuation.CIF20, exposures_1.eExposureValuation.SELLING_PRICE)
        .required(),
    numberOfAnnualSales: joi_1.default.object().keys({
        currency: joi_1.default.string().allow(""),
        value: joi_1.default.when("valuation", {
            is: exposures_1.eExposureValuation.SELLING_PRICE,
            then: joi_1.default.number().min(0).required(),
            otherwise: [joi_1.default.number().min(0).optional(), joi_1.default.allow(null)]
        })
    }),
    annualShipmentVolume: joi_1.default.number().when("valuation", {
        switch: [
            { is: exposures_1.eExposureValuation.CIF10, then: joi_1.default.number().min(0).required() },
            { is: exposures_1.eExposureValuation.CIF20, then: joi_1.default.number().min(0).required() }
        ],
        otherwise: joi_1.default.number().min(0).allow(null).optional()
    }),
    targetPremium: joi_1.default.number().min(0).allow(null).optional()
})
    .required();
exports.policyNumberSchema = joi_1.default.object({
    policyNumber: joi_1.default.string().required()
}).required();
exports.sentToUnderwriterSchema = joi_1.default.object({
    policyNumber: joi_1.default.string().required(),
    otherDocuments: joi_1.default.array().items(joi_1.default.object({
        documentPath: joi_1.default.string().required(),
        documentName: joi_1.default.string().required(),
        bucketName: joi_1.default.string(),
        size: joi_1.default.number(),
        fileType: joi_1.default.string()
    }).unknown())
}).required();
//# sourceMappingURL=policyAnnualCargoSchemas.js.map